import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import XLSX from "xlsx";
import { firebaseDb } from "../../firebase";
import moment from "moment";
// reactstrap components
import { Row, Container, Col, Card, Button } from "reactstrap";
// react component used to create sweet alerts
import SweetAlert from "react-bootstrap-sweetalert";

import DefaultFooter from "../../Components/Footers/DefaultFooter";
import ScrollTransparentNavbar from "../../Components/Navbars/ScrollTransparentNavbar";
import MethodHeader from "../../Components/Headers/MethodHeader";

import * as actions from "../../store/actions/index";

const Method = (props) => {
  const [alert, setAlert] = useState(null);
  const [eventResults, setEventResults] = useState([]);
  const [userResults, setUserResults] = useState([]);

  const eventAlreadyEnteredAlert = () => {
    setAlert(
      <SweetAlert
        warning
        style={{
          display: "block",
          marginTop: "-100px",
          color: "rgb(89, 89, 89)",
        }}
        title="Already Submitted"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="warning"
        show={true}
      >
        You have already submitted a run for this event.
      </SweetAlert>
    );
  };

  const hideAlert = () => {
    setAlert(null);
    props.onGetEventEnteredCleared();
    props.history.push("/profile");
  };

  useEffect(() => {
    if (props.eventEntered) {
      // eventAlreadyEnteredAlert();
    }
  }, [props.eventEntered]);

  useEffect(() => {
    getData();
  }, []);

  const mergeById = (a1, a2) =>
    a1.map((itm) => ({
      ...a2.find((item) => item.userId === itm.userId && item),
      ...itm,
    }));

  const mergeArrayObjects = (arr1, arr2) => {
    const table = mergeById(arr1, arr2);

    // console.table(table);

    // const map = new Map();
    // arr1.forEach((item) => map.set(item.userId, item));
    // arr2.forEach((item) =>
    //   map.set(item.userId, { ...map.get(item.userId), ...item })
    // );
    // const mergedArr = Array.from(map.values());

    // console.log(mergedArr);

    return table;

    // return arr2.map((item, i) => {
    //   if (item.userId === arr1[i].userId) {
    //     return Object.assign({}, item, arr2[i]);
    //   }
    // });
  };

  const getData = () => {
    let data = [];
    let userList = [];

    firebaseDb
      .collection("User_Event")
      .where("eventId", "==", props.selectedEvent.eventId)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          data.push(doc.data());
        });
      });
    firebaseDb
      .collection("User")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          userList.push(doc.data());
        });
      });

    setUserResults(userList);
    setEventResults(data);

    // console.log("completed");
    // console.log("userList", userList);

    // console.log("dataList", data);
  };

  const exportFile = () => {
    // debugger;
    const mergedData = mergeArrayObjects(eventResults, userResults);

    // let workSheetData = [];
    // console.log("hello", mergedData);
    // mergedData.map((item) => {
    //   if (item)
    //     workSheetData.push([
    //       item.firstName,
    //       item.cellNumber,
    //       item.distance,
    //       item.emailAddress,
    //       item.eventName,
    //       item.gender,
    //       item.lastName,
    //       item.time,
    //       item.idNumber,
    //     ]);
    // });

    let dataList = [
      [
        "First Name",
        "Last Name",
        "ID Number",
        "Cell Number",
        "Time",
        "Distance",
        "Event Name",
      ],
    ];

    mergedData.forEach((data) => {
      if (data) {
        // console.log("dataLog", data);
        // debugger;
        let dataArray = [
          data.firstName,
          data.lastName,
          data.idNumber,
          data.cellNumber,
          data.time,
          data.distance,
          data.eventName,
        ];
        dataList.push(dataArray);
      }
    });

    const wb = XLSX.utils.book_new();
    const wsAll = XLSX.utils.aoa_to_sheet(dataList);
    XLSX.utils.book_append_sheet(wb, wsAll, "Event Results");
    XLSX.writeFile(
      wb,
      props.selectedEvent.data.name +
        "_" +
        moment().format("YYYYMMDD") +
        ".xlsx"
    );
  };

  return (
    <>
      <ScrollTransparentNavbar />
      <div className="wrapper">
        <MethodHeader />
        <div className="main">
          {alert}
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h4 className="description">
                  You can either capture your time manually, or we can hook into
                  Strava
                </h4>
              </Col>
            </Row>
            <Row>
              <Col></Col>
              <Col>
                <Card
                  className="card-background card-raised"
                  data-background-color=""
                  style={{
                    cursor: "pointer",
                    backgroundImage:
                      "url(" +
                      require("../../assets/img/pexels-sathesh-d-698808.jpg")
                        .default +
                      ")",
                  }}
                  onClick={() => props.history.push("/ManualCapture")}
                >
                  <div className="info">
                    <div className="icon icon-white">
                      <i className="now-ui-icons gestures_tap-01"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Manual capture</h4>
                    </div>
                  </div>
                </Card>
              </Col>
              <Col>
                <Card
                  className="card-background card-raised"
                  data-background-color=""
                  style={{
                    cursor: "pointer",
                    backgroundImage:
                      "url(" +
                      require("../../assets/img/strava-seeklogo.com.svg")
                        .default +
                      ")",
                  }}
                  onClick={() => props.history.push("/StravaActivities")}
                >
                  <div className="info">
                    <div className="icon icon-white">
                      <i className="now-ui-icons  arrows-1_share-66"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Strava upload</h4>
                    </div>
                  </div>
                </Card>
              </Col>
              {props.adminUser ? (
                <Col>
                  <Card
                    className="card-background card-raised"
                    data-background-color=""
                    style={{
                      cursor: "pointer",
                      backgroundImage:
                        "url(" +
                        require("../../assets/img/pexels-lukas-590022.jpg")
                          .default +
                        ")",
                    }}
                    onClick={() => exportFile()}
                  >
                    <div className="info">
                      <div className="icon icon-white">
                        <i className="now-ui-icons arrows-1_cloud-download-93"></i>
                      </div>
                      <div className="description">
                        <h4 className="info-title">Export Results</h4>
                      </div>
                    </div>
                  </Card>
                </Col>
              ) : null}
              <Col></Col>
            </Row>
          </Container>
        </div>
      </div>
      <DefaultFooter />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    athlete: state.strava.athlete,
    profileImage: state.strava.profileImage,
    firstName: state.strava.firstName,
    lastName: state.strava.lastName,
    city: state.strava.city,
    activities: state.strava.activities,
    authenticated: state.authentication.authenticated,
    event: state.event.events,
    selectedEvent: state.event.selectedEvent,
    user: state.authentication.user,
    eventEntered: state.event.eventEntered,
    adminUser:
      //  true,
      state.authentication.user.emailAddress ===
      process.env.REACT_APP_ADMIN_EMAIL_ADDRESS,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetEventEnteredCleared: () => dispatch(actions.getEventEnteredCleared()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Method);

//getEventEnteredCleared
